import { toast } from "react-toastify";
import { useState } from "react";
import axiosInstance from "../../../../services/axios-client";

const useDefaultRemark = () => {
    const [payload, setPayload] = useState({
        ProjectID: "",
        ProjectPhaseID: "",
        EmployeeID: "",
        CalibratorID: "",
        Comment: "",
    })
    const [isSaving, setIsSaving] = useState(false)
    
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setPayload({...payload, [name]: value})
    }

    const postDefaultRemark = async(handleClose) => {
        try {
            setIsSaving(true)
            let res = await axiosInstance.post(`/auth/calibrations/save-comment`, payload)
            if (res.status == 200) {
                toast.success("Successfully save justification")
                handleClose()
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    return {
        payload,
        setPayload,
        handleOnChange,
        postDefaultRemark,
        isSaving,
    }
}

export default useDefaultRemark